import React from 'react'
import { connect } from 'react-redux'
import BaseContainer from 'components/newsletters/BaseContainer'
import Form from './form'
import StatusDOI from './StatusDOI'
import ConfirmSubscription from 'components/newsletters/shared/messages/ConfirmSubscription'

class FooterContainer extends BaseContainer {

  constructor(props) {
    super(props);
    this.componentName = `FooterContainer-${this.props.elementIndex}`
  }

  render() {
    let { content, view_types } = this.state

    switch(this.props.view) {
      case view_types.new:
        content =
          <Form
            container={this.componentName}
            mainId={this.props.mainId}
            changeFormSuccess={this.changeFormSuccess}
          />
        break;
      case view_types.soi:
        content =
          <div className="col-xs-12 padding-right-xl" style={ {color: "#fff"} }>
            <ConfirmSubscription containerName={ this.componentName } textClasses="color-alert2" buttonClasses="no-border primary" />
          </div>
        break;
      case view_types.doi:
        content = <StatusDOI />
        break;
      default: content = null
    }

    return (
      <section className="row margin-bottom-m">
        {content}
      </section>
    );
  }
}

const mapStateToProps = (state) => ({
  view: state.view
})

export default connect(mapStateToProps, {})(FooterContainer)
